import PropTypes from 'prop-types';
import React from 'react';

import { LAYOUT_CARD_PROFILE, SECTION_CATEGORY } from '@wix/communities-blog-client-common';

import PostListItem from '../../../app/components/post-list-item';
import { getLayoutConfig } from '../../../app/services/layout-config';
import { hasUnpublishedChanges } from '../../../app/services/post-utils';
import withDeviceType from '../../../app/hoc/with-device-type';
import styles from './post-list.scss';

const PostList = ({ posts, onLikeClick, isOwner, isMobile }) => (
  <div>
    {posts.map((post) => (
      <div key={`post-${post._id}`} className={styles.item}>
        <PostListItem
          section={SECTION_CATEGORY}
          layoutType={LAYOUT_CARD_PROFILE}
          type={isMobile ? '' : 'medium'}
          post={post}
          onLikeClick={onLikeClick}
          itemConfig={getLayoutConfig(LAYOUT_CARD_PROFILE).itemConfig}
          hasUnpublishedChanges={isOwner && hasUnpublishedChanges(post)}
        />
      </div>
    ))}
  </div>
);

PostList.propTypes = {
  posts: PropTypes.arrayOf(PropTypes.object),
  onLikeClick: PropTypes.func,
  isOwner: PropTypes.bool,
  isMobile: PropTypes.bool,
};

export default withDeviceType(PostList);
